import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "112vh",
    "& .MuiButtonBase-root": {
      textTransform: "capitalize",
      "&:hover": {
        // backgroundColor: theme.palette.custom.main,
        color: "#000",
      },
    },
    overflow: "auto",
  },
  // loginContainer: {
  // background: "rgba(255, 255, 207, 0)", 
  // // backdropFilter: "blur(10px)",             
  // WebkitBackdropFilter: "blur(10px)",       
  // border: "1px solid rgba(255, 255, 255, 0.3)",
  //   // boxShadow:
  //   // "0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08)",
  //   // borderRadius: 20,
  //   display: "flex",
  //   alignItems: "center",
  //   flexDirection: "column",
  //   margin: "0px 50px",
  //   padding: "40px 50px",
  //   borderRadius:"10px"
  // },
  loginContainer: {
  background: "#fdfdfd",
  borderRadius: "20px",
  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
  border: "1px solid rgba(0,0,0,0.06)",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  padding: "40px",
  margin: "0 auto",
  maxWidth: "420px",
  width: "100%",
},
  // loginWrapper: {
  //   alignItems: "center",
  // },
  // imgContainer: {
  //   alignSelf: "center",
  // },
  gridFields: {
    width: "100%",
    paddingBlock: 8,
  },
  logo: {
    width: 90,
    height: 90,
    objectFit: "cover",
  },
  forgotPassWordLabel: {
    alignSelf: "center",
  },
  forgotLabel: {
    cursor: "pointer",
    opacity: 0.8,
    fontSize: 30,
    paddingBlock: 4,
  },
  fadetext:{
  color:"gray",
  fontWeight:"400 !important"
  },
  password: {
    "&.MuiSvgIcon-root": {
      cursor: "pointer",
    },
  },
  loginPageImage: {
    width: "100%",
    height: "112vh",
    objectFit: "cover",
    position: "relative",
    filter:"brightness(0.8)",
  },
  membersbutton:{
    background:"white"
  },

  loginImageContainer: {
    position: "relative",
  },
  overlayText: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
    flexDirection: "column",
   top: 50,
    left: 0,
    bottom: 50,
    width: "100%",
    //backgroundColor: "rgba(0, 0, 0, 0.6)",
    color: "white",
    padding: "10px",
  },
  gridContainer: {
   height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
    
         
  },
 
loginbanner: {
  position: "relative",
  width: "90%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
},

bannerImg: {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "20px",
},

bannerTextWrapper: {
  position: "absolute",
  top: "60px",
  left: "80px",
  zIndex: 2,
},

bannerText: {
  color: "#3c3c48",
  fontWeight: "900 !important",
  lineHeight: "1.1",
},
  gridItem: {
    flex: "1",
    bottom:0,
   
  },
  boldertext:{
//  fontWeight:"bold",
color:"#000",
marginTop:"10px !important"
 
  },
  boldText: {
    fontSize: "52px",
    fontWeight: "bold",
    color:"#000 !important",
    marginLeft:"10px !important"
  },
  highlightText: {
    color: "#000000",
    marginLeft:"2%",
    fontWeight:"bold"
  },
  highlightTextBig: {
    color: "#c4c4c4",
    fontSize: "52px",
  },

whiteBgBlackText_WhiteBorder: {
  backgroundColor: 'white',
  borderRadius: '10px !important',

  // Label color (default + focused)
  '& .MuiInputLabel-root': {
    color: 'black',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'white',
  },

  // Input text color
  '& .MuiInputBase-input': {
    color: 'black',
  },

  // Outline / border color
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'lightgray',
    },
    '&:hover fieldset': {
      borderColor: 'lightgray',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'lightgray',
    },
  },

  // Helper text color (optional)
  '& .MuiFormHelperText-root': {
    color: '#ffcccc',
  },
},



}));

export default useStyles;
